// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  User,
  signOut,
  RecaptchaVerifier,
  PhoneAuthProvider,
  multiFactor,
  PhoneMultiFactorGenerator,
} from 'firebase/auth';
import { getFirestore, doc, getDoc, setDoc } from 'firebase/firestore';
import firebase from 'firebase/compat';
import { JimboResponse, FirebaseCustomerEmailResponse } from '@models';
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '@services/refreshToken.service';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase
initializeApp(firebaseConfig);

const provider = new GoogleAuthProvider();

export const db = getFirestore();

export const auth = getAuth();

export const createUserDocumentFromAuth = async (userAuth: User, additionalParameters?: any) => {
  const userDocRef = doc(db, 'users', userAuth.uid);

  const userSnapshot = await getDoc(userDocRef);

  if (!userSnapshot.exists()) {
    const { email } = userAuth;
    const createdAt = new Date();

    try {
      await setDoc(userDocRef, {
        email,
        createdAt,
        ...additionalParameters,
      });
    } catch (error: any) {
      console.log('error creating doc', error.message);
    }
  }

  return userDocRef;
};

export const signInWithGoogle = async () => {
  try {
    firebase.initializeApp(firebaseConfig);
    const response = await signInWithPopup(auth, provider);

    console.log('===signin response===', response);
    return response;
  } catch (error) {
    console.log('====google signin===', error);
  }
};

export const signOutUser = async () => await signOut(auth);

export const firebaseApi = createApi({
  reducerPath: 'firebaseProvidersApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['firebase-providers'],
  endpoints: (builder) => ({
    getFirebaseProviders: builder.query<FirebaseCustomerEmailResponse, { email: string }>({
      query: (query) => `/customers/providers?email=${query.email}`,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transformResponse: (response: JimboResponse<FirebaseCustomerEmailResponse>) => response.data!,
      providesTags: ['firebase-providers'],
    }),
  }),
});

export const { useGetFirebaseProvidersQuery } = firebaseApi;

export const recaptchaVerify = (tokenCallback: (arg: string) => void) => {
  try {
    const recaptcha = new RecaptchaVerifier(
      'recaptcha-container',
      {
        size: 'normal',
        callback: (res: string) => {
          tokenCallback(res);
        },
        'expired-callback': () => {
          console.log('callback expired');
        },
      },
      auth,
    );

    recaptcha.render();
    console.log('===recaptcha===', recaptcha);
  } catch (err) {
    console.log('===recaptcha error===', err);
  }

  const recaptchaVerifier = new firebase.auth.RecaptchaVerifier('sign-in-button', {
    size: 'invisible',
    callback: (response: any) => {
      // reCAPTCHA solved, allow signInWithPhoneNumber.
      console.log('===res===', response);
    },
  });

  console.log('===recaptchaVerifier===', recaptchaVerifier);
};

export const phoneVerification = (verificationCodeCallBack: (arg: string) => void) => {
  const recaptcha = new RecaptchaVerifier(
    'recaptcha-container',
    {
      size: 'normal',
      callback: (res: string) => {
        // tokenCallback(res);
        console.log('=res', res);
      },
      'expired-callback': () => {
        console.log('callback expired');
      },
    },
    auth,
  );

  if (auth.currentUser) {
    const multiFactorUser = multiFactor(auth.currentUser);

    try {
      return multiFactorUser
        .getSession()
        .then((multiFactorSession) => {
          const phoneInfoOptions = {
            phoneNumber: '+61414531659',
            session: multiFactorSession,
          };
          const provider = new PhoneAuthProvider(auth);
          return provider.verifyPhoneNumber(phoneInfoOptions, recaptcha);
        })
        .then((verificationId) => {
          console.log('===verification id===', verificationId);
          verificationCodeCallBack(verificationId);
          return verificationId;
        })
        .catch((er) => console.log(er));
    } catch (err: any) {
      console.log('===verification===', err?.code);
    }
  }
};

export const codeVerification = (verificationId: string) => {
  if (auth.currentUser) {
    const multiFactorUser = multiFactor(auth.currentUser);

    try {
      // Ask user for the verification code.
      const cred = PhoneAuthProvider.credential(verificationId, '123456');
      const multiFactorAssertion = PhoneMultiFactorGenerator.assertion(cred);
      // Complete enrollment.
      return multiFactorUser.enroll(multiFactorAssertion, 'My personal phone number');
    } catch (err: any) {
      console.log('===code verification error===', err);
    }
  }
};
